import { http } from '@pendo/http';

export function fetchConfig () {
    return http.get('/api/config').then((res) => res.data);
}

export function fetchPingInformation () {
    return http.get('/ping').then((res) => res.data);
}
